import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  overflow-x:hidden;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  @keyframes shimmer {
    0%{
      background-position: -450px 0;
    }
    100%{
      background-position: 450px 0;
    }
  }
`;
export const Title = styled.div`
  width: 100%;
  height: 2.5rem;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  border-radius: 3px 3px 0px 0px;
  cursor: pointer;
  background-color:#e9ecef;
  background-image: linear-gradient(to right, #e9ecef 0%, rgba(0,0,0,0.05) 20%, #e9ecef 40%, #e9ecef 100%);
  background-repeat: no-repeat;
  background-size: 450px 400px;
  animation: shimmer 2s linear infinite;
`
export const Content = styled.ul`
  display: flex;
  width: 100%;
  max-height: 15rem;
  padding:0.75rem;
  flex-direction: column;
  border-radius: 0px 0px 4px 4px;
  background-color:#f6f6f6;
  gap: 0.5rem;
  overflow-y:auto;

  li{
    display:flex;
    width:100%;
    height: 2rem;
    padding: 0.5rem;
    justify-content:left;
    align-items:center;
    color: #6c757d;
    cursor: pointer;
    border-radius: 4px;
    border-left: 4px solid #e9ecef;
    background-color: #ffffff;
    font-size: 1.1rem;
    background-image: linear-gradient(to right, #ffffff 0%, rgba(0,0,0,0.05) 20%, #ffffff 40%, #ffffff 100%);
    background-repeat: no-repeat;
    background-size: 450px 400px;
    animation: shimmer 2s linear infinite;
  }
`;

